export default __webpack_public_path__ + "static/media/dao-bg@2x.0057c197.webp";